// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "t__plugin-layout__Layout" + "." + "58f1aeb4" + ".chunk.css";
};